import { Asset, TenantStatusCopyType } from "@hydrologiq/gql/graphql"
import Figure from "../generic/Figure"
import FigureContent from "../generic/FigureContent"
import { statusToText } from "@hydrologiq/shared/asset/attributes/status"
import { useCopyStatuses } from "@hydrologiq/shared/providers/helpers/useCopy"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"
import DataConnectionIndicator from "../../data-connections/DataConnectionIndicator"

export interface StatusProps {
  context?: Asset
}

const Status = ({ context }: StatusProps) => {
  const copyStatuses = useCopyStatuses(TenantStatusCopyType.Asset)
  return (
    <Figure
      heading={"Status"}
      headingExtra={context ? <DataConnectionIndicator asset={context as any} showLabel={true} /> : undefined}
      loading={!context}
      compact={isCompactFigure("summary")}
    >
      <FigureContent.Root>
        <FigureContent.SubText>current</FigureContent.SubText>
        <FigureContent.Value>{context && statusToText(context?.status, copyStatuses)}</FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default Status
